/* eslint-disable no-unused-vars */
/* eslint-disable indent */
/* eslint-disable no-undef */
/* eslint-disable */
import urls from "../../api/urls";
import NormalAPI from "../../api";
import axios from "axios";

const { GET_HUB_MANAGER_DASHBOARD, GET_DASHBOARD_SUMMARY, GET_CLICKABLE_HUB_MANAGER_DASHBOARD, GET_CLICKABLE_HUB_MANAGER_DASHBOARD_DOWNLOAD, GET_OUTSCAN_PENDING_INSCAN_TO_HUB_CLICKABLE, DOWNLOAD_OUTSCAN_PENDING_INSCAN_TO_HUB_CLICKABLE } = urls;

/**
 * Calculate barcode types based on operation code and status
 * @param {number} operationCodes - Operation code
 * @param {string} [status] - Status name or card name to distinguish bags vs shipments
 * @returns {number[]} Array of barcode types to include
 */
const calculateBarcodeTypes = (operationCodes, status = null) => {
  // Start with all barcode types
  const allBarcodeTypes = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  // Status names that indicate bags (barcode_type = 4)
  const bagStatuses = [
    "HUB-IN-SCANNED_BAGS",
    "HUB-OUTSCANNED_BAGS",
    "INSCANNED_AT_TRANSIT_BAGS"
  ];

  // Status names that indicate shipments (barcode_type != 4)
  const shipmentStatuses = [
    "HUB-IN-SCANNED_SHIPMENTS",
    "HUB-OUTSCANNED_SHIPMENTS",
    "INSCANNED_AT_TRANSIT_SHIPMENTS",
    "IN_BAG_OUTSCAN_TO_CP"
  ];
  const OUTSCAN_BAG_STATUS = [
    "OUTSCAN_BAG"
  ];

  // Check if status/card name indicates bags (barcode_type == 4)
  // Check exact match first, then check if name contains "BAGS" (case-insensitive)
  const isBagStatus = status && (
    bagStatuses.includes(status) ||
    status.toUpperCase().includes("BAGS")
  );

  // Check if status/card name indicates shipments (barcode_type != 4)
  // Check exact match first, then check if name contains "SHIPMENTS" (case-insensitive)
  const isShipmentStatus = status && (
    shipmentStatuses.includes(status) ||
    status.toUpperCase().includes("SHIPMENTS")
  );

  const isOutscanBagStatus = status && (
    OUTSCAN_BAG_STATUS.includes(status) ||
    status.toUpperCase().includes("OUTSCAN_BAG")
  );
  // If status indicates bags (barcode_type == 4), pass all barcode types including 4
  if (isBagStatus) {
    //return only barcode types including 4
    return allBarcodeTypes.filter(type => type === 4);
  }

  // If status indicates shipments (barcode_type != 4), remove 4
  if (isShipmentStatus) {
    return allBarcodeTypes.filter(type => type !== 4); // Remove 4, keep others
  }

  if (isOutscanBagStatus) {
    return allBarcodeTypes;
  }
  // Operation codes that require barcode_type != 4 (shipments only - remove 4)
  // operation_code = 6 barcode_type != 4 as hub_inscanned_shipments
  // operation_code = 5 barcode_type != 4 as hub_outscanned_shipments
  // operation_code = 9 barcode_type != 4 as inscanned_at_cp
  // operation_code = 20 barcode_type != 4 as inscanned_at_transit_shipments
  const shipmentOnlyCodes = [6, 5, 9, 20];

  // Check if operation code requires shipments only (barcode_type != 4)
  // Only apply if status doesn't indicate bags
  if (shipmentOnlyCodes.includes(operationCodes) && !isBagStatus) {
    return allBarcodeTypes.filter(type => type !== 4); // Remove 4, keep others
  }

  // For all other operation codes, keep all barcode types
  // operation_code = 21 as bagged
  // operation_code = 54 as force_bag_attempted
  // operation_code = 7 as outscan_to_cp
  // operation_code = 48 as in_bag_outscan_to_cp
  // operation_code = 40 as in_bag_inscan
  // operation_code = 41 as in_bag_outscan
  // operation_code = 3 as inscanned
  // operation_code = 11 as out_for_delivery
  // operation_code = 15 as return_initiated
  // operation_code = 45 as rto_out_for_delivery
  // operation_code = 55 as undelivered
  return allBarcodeTypes;
};

const appendHubOverviewDateParams = (params, { fromDate, toDate, bookingDateFrom, bookingDateTo } = {}) => {
  if (fromDate) params.append("fromDate", fromDate);
  if (toDate) params.append("toDate", toDate);
  if (bookingDateFrom) params.append("bookingDateFrom", bookingDateFrom);
  if (bookingDateTo) params.append("bookingDateTo", bookingDateTo);
};

export const HubCPOverviewService = {
  getHubOverviewDashboard: async (hubId = null, fromDate = null, toDate = null, options = {}) => {
    try {
      const { bookingDateFrom = null, bookingDateTo = null } = options;
      let url = urls.GET_HUB_OVERVIEW_DASHBOARD;
      const params = new URLSearchParams();
      if (hubId) params.append("hubId", hubId);
      appendHubOverviewDateParams(params, { fromDate, toDate, bookingDateFrom, bookingDateTo });
      const queryString = params.toString();
      if (queryString) url = `${url}?${queryString}`;
      const response = await NormalAPI.Api(url).getWithHeader(options);
      if (response?.status && response?.response?.data) {
        return response.response.data;
      }
      return null;
    } catch (error) {
      if (error.code !== "ERR_CANCELED") {
        console.error("Error fetching Hub Overview Dashboard:", error);
      }
      throw error;
    }
  },

  getPieChartHubManagerOverview: async (currentHubId = null, fromDate = null, toDate = null, options = {}) => {
    try {
      const { bookingDateFrom = null, bookingDateTo = null } = options;
      let url = urls.GET_PIE_CHART_HUB_MANAGER_OVERVIEW;
      const params = new URLSearchParams();
      if (currentHubId) {
        params.append("currentHubId", currentHubId);
      }
      appendHubOverviewDateParams(params, { fromDate, toDate, bookingDateFrom, bookingDateTo });

      const queryString = params.toString();
      if (queryString) {
        url = `${url}?${queryString}`;
      }

      const response = await NormalAPI.Api(url).getWithHeader(options);

      if (response?.status) {
        const responseData = response?.response?.data;
        if (responseData?.data) {
          return responseData.data;
        }
        // Handle if direct array or wrapped differently, though usage implies {data: [...]}
        if (Array.isArray(responseData)) {
          return responseData;
        }
      }
      return [];
    } catch (error) {
      if (error.code !== "ERR_CANCELED") {
        console.error("Error fetching Pie Chart Manager Overview:", error);
      }
      // Re-throw if it's a cancellation so the component can handle it (or ignore it)
      if (error.code === "ERR_CANCELED") throw error;
      return [];
    }
  },

  getPieChartHubManagerOverviewClickable: async (params) => {
    try {
      const {
        currentHubId,
        status,
        page = 0,
        size = 10,
        fromDate = null,
        toDate = null,
        bookingDateFrom = null,
        bookingDateTo = null,
      } = params;
      const queryParams = new URLSearchParams({
        status,
        page: String(page),
        size: String(size),
      });
      if (currentHubId) queryParams.append("currentHubId", currentHubId);
      appendHubOverviewDateParams(queryParams, { fromDate, toDate, bookingDateFrom, bookingDateTo });
      const url = `${urls.GET_PIE_CHART_HUB_MANAGER_OVERVIEW_CLICKABLE}?${queryParams.toString()}`;
      const response = await NormalAPI.Api(url).getWithHeader();
      if (response?.status) {
        return response.response.data;
      }
      return null;
    } catch (error) {
      console.error("Error fetching Pie Chart Clickable Report:", error);
      throw error;
    }
  },

  getPieChartHubManagerOverviewClickableDownload: async (params) => {
    try {
      const {
        currentHubId,
        status,
        fromDate = null,
        toDate = null,
        bookingDateFrom = null,
        bookingDateTo = null,
      } = params;
      const queryParams = new URLSearchParams({ status });
      if (currentHubId) queryParams.append("currentHubId", currentHubId);
      appendHubOverviewDateParams(queryParams, { fromDate, toDate, bookingDateFrom, bookingDateTo });
      return `${urls.DOWNLOAD_PIE_CHART_HUB_MANAGER_OVERVIEW_CLICKABLE}?${queryParams.toString()}`;
    } catch (error) {
      console.error("Error generating Pie Chart download URL:", error);
      throw error;
    }
  },
  /**
   * Fetch Hub Manager Dashboard data
   * @param {number|number[]} hubId - Single hub ID or array of hub IDs
   * @param {Object} [options] - Additional options (e.g., signal for AbortController)
   * @returns {Promise<Object>} Response data containing today, yesterday, and tillDate status data
   */
  getHubManagerDashboard: async (hubId, options = {}) => {
    try {
      let url = GET_HUB_MANAGER_DASHBOARD;

      // If hubId is null, don't add query parameter (means all hubs)
      if (hubId === null) {
        // No query parameter - backend will return data for all hubs
        url = GET_HUB_MANAGER_DASHBOARD;
      } else if (Array.isArray(hubId) && hubId.length > 0) {
        if (hubId.length === 1) {
          // Single hub in array
          url = `${GET_HUB_MANAGER_DASHBOARD}?hubId=${hubId[0]}`;
        } else {
          // Multiple hubs - send as comma-separated
          const hubIdsParam = hubId.join(",");
          url = `${GET_HUB_MANAGER_DASHBOARD}?hubId=${hubIdsParam}`;
        }
      } else if (hubId) {
        // Single hub ID
        url = `${GET_HUB_MANAGER_DASHBOARD}?hubId=${hubId}`;
      } else {
        // No hubId provided - return all hubs data
        url = GET_HUB_MANAGER_DASHBOARD;
      }

      const response = await NormalAPI.Api(url).getWithHeader();

      // Check if response is successful
      if (response?.status) {
        const responseData = response?.response?.data;

        // Handle API response structure: { status: true, data: {...} }
        if (responseData?.status === true && responseData?.data) {
          return {
            data: responseData.data,
            message: "Success",
          };
        }
        // Handle direct data response (if API returns data directly)
        if (responseData) {
          return {
            data: responseData,
            message: "Success",
          };
        }
      }
      throw new Error(response?.response?.data?.message || "Failed to fetch Hub Manager Dashboard data");
    } catch (error) {
      console.error("Error fetching Hub Manager Dashboard data:", error);
      throw error;
    }
  },

  /**
   * Fetch Dashboard Summary data for TopCard
   * @param {number|number[]} hubId - Single hub ID or array of hub IDs (optional, if not provided, fetches for all selected hubs)
   * @param {Object} [options] - Additional options (e.g., signal for AbortController)
   * @returns {Promise<Object>} Response data containing today, yesterday, and tillDate card data
   */
  getDashboardSummary: async (hubId = null, options = {}) => {
    try {
      let url = GET_DASHBOARD_SUMMARY;

      // If hubId is null, don't add query parameter (means all hubs)
      if (hubId === null) {
        // No query parameter - backend will return data for all hubs
        url = GET_DASHBOARD_SUMMARY;
      } else if (Array.isArray(hubId) && hubId.length > 0) {
        if (hubId.length === 1) {
          // Single hub in array
          url = `${GET_DASHBOARD_SUMMARY}?hubId=${hubId[0]}`;
        } else {
          // Multiple hubs - send as comma-separated
          const hubIdsParam = hubId.join(",");
          url = `${GET_DASHBOARD_SUMMARY}?hubId=${hubIdsParam}`;
        }
      } else if (hubId) {
        // Single hub ID
        url = `${GET_DASHBOARD_SUMMARY}?hubId=${hubId}`;
      }
      // If hubId is undefined or empty, use base URL (all hubs)

      const response = await NormalAPI.Api(url).getWithHeader();

      // Check if response is successful
      if (response?.status) {
        const responseData = response?.response?.data;

        // Handle API response structure: { status: true, data: {...} }
        if (responseData?.status === true && responseData?.data) {
          return {
            data: responseData.data,
            message: "Success",
          };
        }

        // Handle direct data response (if API returns data directly)
        if (responseData) {
          return {
            data: responseData,
            message: "Success",
          };
        }
      }
      throw new Error(response?.response?.data?.message || "Failed to fetch Dashboard Summary data");
    } catch (error) {
      console.error("Error fetching Dashboard Summary data:", error);
      throw error;
    }
  },

  /**
   * Fetch clickable Hub Manager Dashboard data (detailed shipment list)
   * @param {Object} params - Query parameters
   * @param {string} params.dateFilter - Comma-separated date filters: "tillDate,today,yesterday"
   * @param {number} params.operationCodes - Operation code (single code)
   * @param {number|null} params.hubId - Hub ID (single hub) or null for all hubs
   * @param {string} [params.status] - Status name to distinguish bags vs shipments
   * @param {number} [params.page=0] - Page number (default: 0)
   * @param {number} [params.size=5] - Page size (default: 5)
   * @param {Object} [options] - Additional options (e.g., signal for AbortController)
   * @returns {Promise<Object>} Response data containing shipment list
   */
  getClickableHubManagerDashboard: async (params, options = {}) => {
    try {
      const { dateFilter, operationCodes, hubId, status, page = 0, size = 5 } = params;

      if (!dateFilter || !operationCodes) {
        throw new Error("dateFilter and operationCodes are required");
      }

      // Calculate barcode types based on operation code and status
      const barcodeTypes = calculateBarcodeTypes(operationCodes, status);

      // Build query parameters
      const queryParams = new URLSearchParams({
        dateFilter: dateFilter,
        operationCodes: String(operationCodes),
        page: String(page),
        size: String(size),
        barcodeTypes: barcodeTypes.join(","), // Add barcodeTypes parameter
      });

      // Only add hubId if it's not null (null means all hubs)
      if (hubId !== null && hubId !== undefined) {
        queryParams.append("hubId", String(hubId));
      }

      const url = `${GET_CLICKABLE_HUB_MANAGER_DASHBOARD}?${queryParams.toString()}`;

      const response = await NormalAPI.Api(url).getWithHeader();

      // Check if response is successful
      if (response?.status) {
        const responseData = response?.response?.data;

        // Handle API response structure: { status: true, data: [...], totalCount: ... }
        if (responseData?.status === true) {
          return {
            data: responseData.data || [],
            totalCount: responseData.totalCount || 0,
            message: responseData.message || "Success",
          };
        }

        // Handle direct data response
        if (responseData) {
          return {
            data: responseData.data || responseData || [],
            totalCount: responseData.totalCount || 0,
            message: "Success",
          };
        }
      }
      throw new Error(response?.response?.data?.message || "Failed to fetch clickable Hub Manager Dashboard data");
    } catch (error) {
      console.error("Error fetching clickable Hub Manager Dashboard data:", error);
      throw error;
    }
  },

  /**
   * Download clickable Hub Manager Dashboard report
   * @param {Object} params - Query parameters
   * @param {string} params.dateFilter - Comma-separated date filters: "tillDate,today,yesterday"
   * @param {number} params.operationCodes - Operation code (single code)
   * @param {number|null} params.hubId - Hub ID (single hub) or null for all hubs
   * @param {string} [params.status] - Status name to distinguish bags vs shipments
   */
  getClickableHubManagerDashboardDownload: async (params) => {
    try {
      const { dateFilter, operationCodes, hubId, status } = params;

      if (!dateFilter || !operationCodes) {
        throw new Error("dateFilter and operationCodes are required");
      }

      // Calculate barcode types based on operation code and status (REUSING SAME LOGIC)
      const barcodeTypes = calculateBarcodeTypes(operationCodes, status);

      // Build query parameters
      const queryParams = new URLSearchParams({
        dateFilter: dateFilter,
        operationCodes: String(operationCodes),
        barcodeTypes: barcodeTypes.join(","),
      });

      // Only add hubId if it's not null (null means all hubs)
      if (hubId !== null && hubId !== undefined) {
        queryParams.append("hubId", String(hubId));
      }

      const url = `${GET_CLICKABLE_HUB_MANAGER_DASHBOARD_DOWNLOAD}?${queryParams.toString()}`;
      return url;

    } catch (error) {
      console.error("Error generating download URL:", error);
      throw error;
    }
  },

  getTotalAvailableShipmentsClickable: async (params) => {
    try {
      const {
        currentHubId,
        page = 0,
        size = 10,
        fromDate = null,
        toDate = null,
        bookingDateFrom = null,
        bookingDateTo = null,
      } = params;
      const queryParams = new URLSearchParams({
        page: String(page),
        size: String(size),
      });
      if (currentHubId) queryParams.append("currentHubId", currentHubId);
      appendHubOverviewDateParams(queryParams, { fromDate, toDate, bookingDateFrom, bookingDateTo });
      const url = `${urls.GET_TOTAL_AVAILABLE_SHIPMENTS_CLICKABLE}?${queryParams.toString()}`;
      const response = await NormalAPI.Api(url).getWithHeader();
      if (response?.status) {
        const responseData = response?.response?.data;
        if (responseData) {
          return {
            data: responseData.data || [],
            totalCount: responseData.count || 0,
            message: responseData.message || "Success",
          };
        }
      }
      return { data: [], totalCount: 0, message: "Failed" };
    } catch (error) {
      console.error("Error fetching Total Available Shipments Clickable Report:", error);
      throw error;
    }
  },

  getTotalAvailableShipmentsClickableDownload: async (params) => {
    try {
      const {
        currentHubId,
        fromDate = null,
        toDate = null,
        bookingDateFrom = null,
        bookingDateTo = null,
      } = params;
      let url = urls.DOWNLOAD_TOTAL_AVAILABLE_SHIPMENTS_CLICKABLE;
      const queryParams = new URLSearchParams();
      if (currentHubId) queryParams.append("currentHubId", currentHubId);
      appendHubOverviewDateParams(queryParams, { fromDate, toDate, bookingDateFrom, bookingDateTo });
      const qs = queryParams.toString();
      if (qs) url += `?${qs}`;
      return url;
    } catch (error) {
      console.error("Error generating Total Available Shipments download URL:", error);
      throw error;
    }
  },

  getOutscanPendingInscanToCpClickable: async (params) => {
    try {
      const {
        currentHubId,
        page = 0,
        size = 10,
        fromDate = null,
        toDate = null,
        bookingDateFrom = null,
        bookingDateTo = null,
      } = params;
      const queryParams = new URLSearchParams();
      
      if (currentHubId !== null && currentHubId !== undefined && currentHubId !== "" && currentHubId !== "null") {
        queryParams.append("currentHubId", currentHubId);
      }
      
      queryParams.append("page", page);
      queryParams.append("size", size);
      appendHubOverviewDateParams(queryParams, { fromDate, toDate, bookingDateFrom, bookingDateTo });

      const url = `${urls.GET_OUTSCAN_PENDING_INSCAN_TO_CP_CLICKABLE}?${queryParams.toString()}`;
      console.log("Calling API in Service:", url);
      const response = await NormalAPI.Api(url).getWithHeader();

      if (response?.status && response?.response?.data) {
        return response.response.data;
      }
      return { data: [], totalCount: 0 };
    } catch (error) {
      console.error("Error fetching Outscan Pending Inscan To CP data:", error);
      throw error;
    }
  },

  getOutscanPendingInscanToCpClickableDownload: async (params) => {
    try {
      const {
        currentHubId,
        fromDate = null,
        toDate = null,
        bookingDateFrom = null,
        bookingDateTo = null,
      } = params;
      const queryParams = new URLSearchParams();
      
      if (currentHubId !== null && currentHubId !== undefined && currentHubId !== "" && currentHubId !== "null") {
        queryParams.append("currentHubId", currentHubId);
      }
      appendHubOverviewDateParams(queryParams, { fromDate, toDate, bookingDateFrom, bookingDateTo });
      
      const url = `${urls.DOWNLOAD_OUTSCAN_PENDING_INSCAN_TO_CP_CLICKABLE}?${queryParams.toString()}`;
      return url;
    } catch (error) {
      console.error("Error generating Outscan Pending Inscan To CP download URL:", error);
      throw error;
    }
  },
  getOutscanPendingInscanToHubClickable: async (params, options = {}) => {
    try {
      const {
        tripStartHubId,
        page = 0,
        size = 10,
        fromDate = null,
        toDate = null,
        bookingDateFrom = null,
        bookingDateTo = null,
      } = params;
      const queryParams = new URLSearchParams();
      queryParams.append("page", page);
      queryParams.append("size", size);
      if (tripStartHubId) queryParams.append("tripStartHubId", tripStartHubId);
      appendHubOverviewDateParams(queryParams, { fromDate, toDate, bookingDateFrom, bookingDateTo });
      const url = `${GET_OUTSCAN_PENDING_INSCAN_TO_HUB_CLICKABLE}?${queryParams.toString()}`;

      const response = await axios.get(url, { signal: options.signal });

      if (response?.status === 200 && response?.data) {
        return response.data;
      }
      return { data: [], totalCount: 0 };
    } catch (error) {
      console.error("Error fetching Outscan Pending Inscan To Hub data:", error);
      throw error;
    }
  },

  getOutscanPendingInscanToHubClickableDownload: async (params) => {
    try {
      const {
        tripStartHubId,
        fromDate = null,
        toDate = null,
        bookingDateFrom = null,
        bookingDateTo = null,
      } = params;
      let url = DOWNLOAD_OUTSCAN_PENDING_INSCAN_TO_HUB_CLICKABLE;

      const queryParams = new URLSearchParams();
      if (tripStartHubId) queryParams.append("tripStartHubId", tripStartHubId);
      appendHubOverviewDateParams(queryParams, { fromDate, toDate, bookingDateFrom, bookingDateTo });
      const qs = queryParams.toString();
      if (qs) url += `?${qs}`;

      return url;
    } catch (error) {
      console.error("Error generating Outscan Pending Inscan To Hub download URL:", error);
      throw error;
    }
  },

  getInboundPendencyClickable: async (params) => {
    try {
      const {
        tripEndHubId,
        page = 0,
        size = 10,
        fromDate = null,
        toDate = null,
        bookingDateFrom = null,
        bookingDateTo = null,
      } = params;
      const queryParams = new URLSearchParams();
      queryParams.append("page", page);
      queryParams.append("size", size);
      if (tripEndHubId) queryParams.append("tripEndHubId", tripEndHubId);
      appendHubOverviewDateParams(queryParams, { fromDate, toDate, bookingDateFrom, bookingDateTo });
      const url = `${urls.GET_INBOUND_PENDENCY_CLICKABLE}?${queryParams.toString()}`;

      const response = await NormalAPI.Api(url).getWithHeader();

      if (response?.status && response?.response?.data) {
        return response.response.data;
      }
      return { data: [], totalCount: 0 };
    } catch (error) {
      console.error("Error fetching Inbound Pendency data:", error);
      throw error;
    }
  },

  getInboundPendencyClickableDownload: async (params) => {
    try {
      const {
        tripEndHubId,
        fromDate = null,
        toDate = null,
        bookingDateFrom = null,
        bookingDateTo = null,
      } = params;
      let url = urls.DOWNLOAD_INBOUND_PENDENCY_CLICKABLE;

      const queryParams = new URLSearchParams();
      if (tripEndHubId) queryParams.append("tripEndHubId", tripEndHubId);
      appendHubOverviewDateParams(queryParams, { fromDate, toDate, bookingDateFrom, bookingDateTo });
      const qs = queryParams.toString();
      if (qs) url += `?${qs}`;

      return url;
    } catch (error) {
      console.error("Error generating Inbound Pendency download URL:", error);
      throw error;
    }
  },
};
